import { Component, OnInit, OnDestroy } from '@angular/core';
import { Constants } from '../../constants';
import { Router } from '@angular/router';

import { Subscription } from 'rxjs/Subscription';
import { MatDialog } from '@angular/material';
import { UserAgentDialogComponent } from '../user-agent-dialog/user-agent-dialog.component';
import  * as UAParser from 'ua-parser-js';

import { CommercialService } from '@core/services';
import { Commercial } from '@shared/models';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.css']
})
export class HomePageComponent implements OnInit, OnDestroy {

  public loading: boolean;
  public commercial: Commercial;
  public maintenanceMode: boolean;
  commercialSubscription: Subscription;

  private parser = new UAParser();

  constructor(
    private _router: Router,
    private _commercialService: CommercialService,
    private _dialog: MatDialog) {
  }

  ngOnInit() {
    this.maintenanceMode = Constants.MAINTENANCE_MODE;
    this.commercialSubscription = this._commercialService.getCommercialValue().subscribe(
      commercialVal => {
        this.commercial = commercialVal;
        console.log('home page ', this.commercial.isCommercialDomain );
      }
    )

    if (localStorage.getItem(Constants.TOKEN) || sessionStorage.getItem(Constants.TOKEN)) {
      this._router.navigateByUrl('/autologin');
    }
  }

  showUserAgentDialog() {
    const userAgent = this.parseUserAgent(navigator.userAgent);
    let dialogRef = this._dialog.open(UserAgentDialogComponent, {
        data: {
            message: userAgent,
            alertType: 'primary',
            title: 'Browser Details'
        }
    });

  }

  private parseUserAgent(userAgent) {
    this.parser.setUA(userAgent);
    const browser = this.parser.getBrowser();
    const os = this.parser.getOS();
    const device = this.parser.getDevice();
    return `${os.name} ${os.version}, ${browser.name} ${browser.version}`;

  }

  ngOnDestroy(){
    this.commercialSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/home-page/home-page.component.ts